import { getErrorMessage } from "../getErrorMessage";
import type { Validator } from "./types";

export const regex: Validator = ({
  name,
  answer,
  validation,
  questionErrorMessage,
  fallbackMessage,
}) => {
  const expression = validation.value as string;
  const valid = new RegExp(expression).test(answer);

  return {
    id: name,
    valid,
    message: valid
      ? undefined
      : getErrorMessage({
          validationMessage: validation.message,
          questionErrorMessage,
          fallbackMessage,
        }),
  };
};

export const caseInsensitiveRegex: Validator = ({
  name,
  answer,
  validation,
  questionErrorMessage,
  fallbackMessage,
}) => {
  const expression = validation.value as string;
  const valid = new RegExp(expression, "i").test(answer);

  return {
    id: name,
    valid,
    message: valid
      ? undefined
      : getErrorMessage({
          validationMessage: validation.message,
          questionErrorMessage,
          fallbackMessage,
        }),
  };
};
